"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAST_VISIT_DAYS_LEGEND_LABELS = void 0;
var LAST_VISIT_DAYS_LEGEND_LABELS;
(function (LAST_VISIT_DAYS_LEGEND_LABELS) {
    LAST_VISIT_DAYS_LEGEND_LABELS["TODAY"] = "Today";
    LAST_VISIT_DAYS_LEGEND_LABELS["YESTERDAY"] = "Yesterday";
    LAST_VISIT_DAYS_LEGEND_LABELS["LAST_7_DAYS"] = "Last 7 Days";
    LAST_VISIT_DAYS_LEGEND_LABELS["LAST_30_DAYS"] = "Last 30 Days";
    LAST_VISIT_DAYS_LEGEND_LABELS["MORE_THAN_30_DAYS"] = "More than 30 Days";
    LAST_VISIT_DAYS_LEGEND_LABELS["NEVER"] = "Never";
})(LAST_VISIT_DAYS_LEGEND_LABELS || (exports.LAST_VISIT_DAYS_LEGEND_LABELS = LAST_VISIT_DAYS_LEGEND_LABELS = {}));
